'use strict';

const Mn = require('backbone.marionette');
const i18n = require('i18next');
const Router = require('balus/app/router/index');
const Dialog = require('common/util/dialog');
const Logger = require('common/util/logger');
const ProjectDeleteService = require('common/app/service/project/delete');
const ProjectPermission = require('common/domain/entity/project-permission');
const ModalView = require('common/ui/view/modal/index');
const ActionRepository = require('process/domain/repository/action/index');
const ActionContext = require('process/domain/value/context');
const ActionStateView = require('process/ui/view/action/state');
const ActionDateView = require('process/ui/view/action/date');
const NavWidthChanger = require('balus/ui/view/nav-width-changer');
const ProjectSettingView = require('balus/ui/view/body/project/modal/project-setting');
const DescriptionView = require('balus/ui/view/body/project/nav/description');
const Template = require('balus/ui/template/body/project/nav/index.hbs');

module.exports = Mn.View.extend({
    template: Template,
    modelEvents: {
        change: 'render'
    },
    regions: {
        projectActionState: '.project-action-state',
        projectActionDate: '.project-action-date',
        desc: '.project-description-wrapper',
        widthChanger: '#nav-width-changer-wrapper'
    },
    ui: {
        projectEditButton: '.edit-project',
        projectDeleteButton: '.delete-project',
    },
    events: {
        'click @ui.projectEditButton': 'editProject',
        'click @ui.projectDeleteButton': 'deleteProject'
    },

    templateContext: function() {
        const context = this.getOption('context');
        const isEditable = context.getProjectRole().getPermission(
            ProjectPermission.ProjectEditPermission
        ).isPermitted(context);
        return {
            isEditable: isEditable
        };
    },

    onRender: function() {
        const context = this.getOption('context');
        const actionID = this.model.getActionID();

        ActionRepository.find(this.model).get(actionID)
            .then(action => {
                const actionContext = ActionContext.build(context, action);
                this.showChildView('projectActionState', new ActionStateView({
                    model: action,
                    context: actionContext
                }));
                this.showChildView('projectActionDate', new ActionDateView({
                    model: action,
                    context: actionContext
                }));
            });

        this.showChildView('desc', new DescriptionView({
            model: this.model,
            context: context
        }));

        this.showChildView('widthChanger', new NavWidthChanger());
    },

    editProject: function() {
        const context = this.getOption('context');
        const group = context.getGroup();
        const user = context.getUser();

        const modal = new ModalView({
            model: this.model,
            title: i18n.t('title.project.setting'),
            bodyView: new ProjectSettingView({
                model: this.model,
                context: context,
                group: group,
                user: user
            }),
            large: true,
            onChildviewSave: function() {
                this.disableButtons();
                this.getOption('bodyView').setting()
                    .then(() => {
                        this.hide();
                        this.trigger('change:model');
                    });
            }
        });
        modal.show();
        this.listenTo(modal, 'change:model', () => { this.trigger('change:model'); });
    },

    /**
     * Project 削除の confirmation
     */
    deleteProject: function() {
        Dialog.confirm({
            text: i18n.t('notify.delete-confirm', {name: this.model.get('name')}),
            okCallback: () => {
                this.deletingProject();
            }
        });
    },

    /**
     * Project の削除
     */
    deletingProject: function() {
        const context = this.getOption('context');
        const group = context.getGroup();
        Logger.info('Project deleting ...', this.model);
        const projectDeleteService = new ProjectDeleteService(group, this.model);

        projectDeleteService.delete()
            .then(() => {
                Router.navigate(`/groups/${this.model.getGroupId()}`, {trigger: true});
            });
    }
});



// WEBPACK FOOTER //
// ./balus/ui/view/body/project/nav/index.js